import { useCallback, useMemo } from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import type { HeadlineSmallTwoLineWithTimerProps } from './types';
import { bridge, isNil, isNotNil, renderHTMLToText } from '../../../../utils';
import type { IScreensLogging } from '../../../../api/types';
import { ViewAllButton } from '../ViewAllButton';

export const HeadlineSmallTwoLineWithTimer = ({
  header,
}: HeadlineSmallTwoLineWithTimerProps) => {
  const handlePressViewAll = useCallback(() => {
    if (header?.item.deeplink) {
      logClickViewAllButton({ logging: header.logging });
      bridge.openDeeplink(header.item.deeplink);
    }
  }, [header?.item.deeplink, header?.logging]);

  const subTitleElement = useMemo(() => {
    if (isNil(header?.item.sub_title)) return null;
    return renderHTMLToText(header.item.sub_title);
  }, [header?.item.sub_title]);

  if (isNil(header)) return null;

  const hasDeeplink = isNotNil(header.item.deeplink);

  return (
    <Flex.Row
      padding={{ top: 24, bottom: 16 }}
      alignItems="center"
    >
      <Flex.Column
        gap={2}
        flex={1}
        padding={{ left: 16, right: hasDeeplink ? 0 : 16 }}
      >
        <Typography type="h5" color="content_primary">
          {header.item.title}
        </Typography>
        {subTitleElement && (
          <Typography type="body2" color="content_secondary">
            {subTitleElement}
          </Typography>
        )}
      </Flex.Column>

      {hasDeeplink && (
        <Flex padding={{ right: 4 }}>
          <ViewAllButton onPress={handlePressViewAll} />
        </Flex>
      )}
    </Flex.Row>
  );
};

const logClickViewAllButton = ({ logging }: { logging: IScreensLogging }) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_HEADLINE_SMALL_TWO_LINE_MORE',
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });
};
